import { render } from "./Piece.vue?vue&type=template&id=99a44f56"
import script from "./Piece.vue?vue&type=script&lang=js"
export * from "./Piece.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__